import React from 'react'
import styled from 'styled-components'
import { Typography, IconButton } from '@material-ui/core'
import { ExpandMore, ExpandLess } from '@material-ui/icons'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import {
  toggleGroup,
  selectExpandedGroups,
} from 'features/CamerasView/camerasViewSlice'
import CameraCard from './CameraCard'

const GroupWrapper = styled.div`
  margin-bottom: 32px;
`

const GroupHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  cursor: pointer;
  user-select: none;

  &:hover {
    opacity: 0.8;
  }
`

const AddressText = styled(Typography)`
  && {
    font-family: 'Inter', 'Open Sans', sans-serif;
    font-size: 16px;
    font-weight: 600;
    color: #051125;
  }
`

const CityLabel = styled.span`
  font-family: 'Open Sans', sans-serif;
  font-size: 13px;
  color: #8f9bb3;
  margin-left: 4px;
`

const TypeBadge = styled.span`
  font-family: 'Open Sans', sans-serif;
  font-size: 11px;
  font-weight: 600;
  color: #ffffff;
  background: #8f9bb3;
  padding: 2px 8px;
  border-radius: 6px;
  text-transform: uppercase;
`

const CountBadge = styled.span`
  font-family: 'Open Sans', sans-serif;
  font-size: 13px;
  color: #8f9bb3;
`

const OnlineIndicator = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: ${(p) => (p.online ? '#0FBA81' : '#FF3D71')};
  font-weight: 500;

  &::before {
    content: '';
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: currentColor;
  }
`

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media (max-width: 900px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`

function CamerasGroup({ group }) {
  const dispatch = useDispatch()
  const { t } = useTranslation(['cameras_view'])
  const expandedGroups = useSelector(selectExpandedGroups)
  const isExpanded = expandedGroups[group.key] !== false

  const onlineCount = group.cameras.filter((c) => c.is_online).length
  const offlineCount = group.cameras.length - onlineCount

  const handleToggle = () => {
    dispatch(toggleGroup(group.key))
  }

  return (
    <GroupWrapper>
      <GroupHeader onClick={handleToggle}>
        <IconButton size="small" style={{ padding: 4 }}>
          {isExpanded ? <ExpandLess /> : <ExpandMore />}
        </IconButton>
        {group.type === 'gate' && (
          <TypeBadge>{t('cameras_view:gate')}</TypeBadge>
        )}
        <AddressText>{group.key}</AddressText>
        {group.city && <CityLabel>({group.city})</CityLabel>}
        <CountBadge>{group.cameras.length}</CountBadge>
        <OnlineIndicator online>{onlineCount}</OnlineIndicator>
        {offlineCount > 0 && <OnlineIndicator>{offlineCount}</OnlineIndicator>}
      </GroupHeader>
      {isExpanded && (
        <Grid>
          {group.cameras.map((camera) => (
            <CameraCard key={camera.uuid} camera={camera} />
          ))}
        </Grid>
      )}
    </GroupWrapper>
  )
}

export default CamerasGroup
